import React from 'react'
import { Form, Input, Button, Col, Row, Space, Select, DatePicker } from 'antd'
import { shallowEqual, useSelector } from 'react-redux'

export function SearchForm(props) {
    const { onSubmit, onReset, defaultQuery } = props

    const employeeList = useSelector((state) => state.roster.employeeList)

    const [form] = Form.useForm()
    const handleReset = () => {
        form.resetFields()
        onReset({ title: undefined })
    }
    React.useEffect(() => {
        if (!defaultQuery) {
            return
        }
        const { title } = defaultQuery
        if (title) {
            form.setFieldsValue({ title })
        }
    }, [form, defaultQuery])

    const periodEndingChange = value => {
        console.log(`selected ${value}`)
    }

    const onPeriodDateChange = (date, dateString) => {
        console.log(date, dateString)
    }

    const displayEmployees = () => {
        const empOption = employeeList.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    return (
        <Form
            form={form}
            initialValues={{}}
            layout="vertical"
            onFinish={onSubmit}
        >
            <Row gutter={{ md: 24 }}>
                <Col xs={8} sm={8} md={6} lg={6}>
                    <div className="m-1 p-1">
                        <Form.Item
                            name="range"
                            label="Timesheets period"
                            initialValue={props.defaultQuery.range}
                        >
                            <Select
                                onChange={periodEndingChange}
                                options={[
                                    {
                                        value: 'week',
                                        label: 'Week',
                                    },
                                    {
                                        value: 'fortnight',
                                        label: 'Fortnight',
                                    },
                                    {
                                        value: 'month',
                                        label: 'Month',
                                    },
                                ]}
                            />
                        </Form.Item>
                    </div>
                </Col>
                <Col xs={8} sm={8} md={6} lg={6}>
                    <div className="m-1 p-1">
                        <Form.Item name="end" label="End of period" initialValue={props.defaultQuery.end}>
                            <DatePicker onChange={onPeriodDateChange} />
                        </Form.Item>
                    </div>
                </Col>
                <Col xs={8} sm={8} md={6} lg={6}>
                    <div className="m-1 p-1">
                        <Form.Item
                            name="status"
                            label="Status"
                            initialValue={props.defaultQuery.status}
                        >
                            <Select
                                onChange={periodEndingChange}
                                options={[
                                    {
                                        value: 'Any',
                                        label: 'Any',
                                    },
                                    {
                                        value: 0,
                                        label: 'Rostered',
                                    },
                                    {
                                        value: 1,
                                        label: 'Approved',
                                    },
                                ]}
                            />
                        </Form.Item>
                    </div>
                </Col>
            </Row>
            <Row gutter={{ md: 24 }}>
                <Col xs={24} sm={12} md={8} lg={8}>
                    <div className="m-1 p-1">
                        <Form.Item name="employees" label="Employee" initialValue={props.defaultQuery.employees}>
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder="Select employees"
                                maxTagCount="responsive"
                                filterOption={(input, option) =>
                                    (option?.label ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                onChange={periodEndingChange}
                                options={displayEmployees()}
                            />
                        </Form.Item>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                    <div className="m-1 p-1">
                        <Form.Item name="note" label="Note" initialValue={props.defaultQuery.note}>
                            <Input placeholder="note" maxLength={10} />
                        </Form.Item>
                    </div>
                </Col>
            </Row>

            <Space>
                <Button htmlType="submit" type="primary">
                    Search
                </Button>
                <Button htmlType="button" onClick={handleReset}>
                    Reset
                </Button>
            </Space>
        </Form>
    )
}
